import React, { useContext } from 'react';
import LanguageContext from '../LanguageContext';
import translations from '../utils/translation';
import Menu from '../components/Menu';

const Degustation = () => {
  const { language } = useContext(LanguageContext);
  const content = translations.degustation[language];

  return (
    <div className="main-section">
      <Menu />
      <h1 className="wine-title">{content.title}</h1>
      <div className="wine-paragraph">
        <p><strong>{content.tempTitle}</strong> : {content.tempText}</p>
        <p><strong>{content.glassTitle}</strong> : {content.glassText}</p>
        <p><strong>{content.carafeTitle}</strong> : {content.carafeText}</p>
        <p><strong>{content.decantTitle}</strong> : {content.decantText}</p>
      </div>
    </div>
  );
};

export default Degustation;

